import React, { Fragment, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Table from './Table';
import FormModal from './FormModal';
import './AdminHelpDesk.scss';
import { Helmet } from 'react-helmet';
import Layout from './../Layout';
import * as actions from './AdminHelpDesk.actions';
import * as selectors from './AdminHelpDesk.selectors';
import { stringifyEqualityCheck } from './../../utils';
import * as dialog from './../common/dialog';
import * as loginSelectors from './../Login/Login.selectors';

const AdminHelpDesk = (props) => {
    /* State to props */
    const requests = useSelector(selectors.getRequests, stringifyEqualityCheck);
    const fetching = useSelector(selectors.getFetching);
    const sending = useSelector(selectors.getSending);
    const idModal = useSelector(selectors.getIdModal);
    const pagination = useSelector(selectors.getPagination, stringifyEqualityCheck);
    const request = useSelector(selectors.getRequest, stringifyEqualityCheck);
    const sort = useSelector(selectors.getSort, stringifyEqualityCheck);
    const responseMessage = useSelector(selectors.getResponseMessage);
    const closingTicket = useSelector(selectors.getClosingTicket);
    const user = useSelector(loginSelectors.getUser, stringifyEqualityCheck);

    /* Dispatch to props */
    const dispatch = useDispatch();
    const fetchRequests = useCallback((type) => dispatch(actions.fetchRequests(type)), [dispatch]);
    const setIdModal = useCallback((id) => dispatch(actions.setIdModal(id)), [dispatch]);
    const setActivePage = useCallback((value) => dispatch(actions.setActivePage(value)), [dispatch]);
    const resetState = useCallback(() => dispatch(actions.resetState()), [dispatch]);
    const setRequest = useCallback((id) => dispatch(actions.setRequest(id)), [dispatch]);
    const setRequestField = useCallback((field, value) => dispatch(actions.setRequestField(field, value)), [dispatch]);
    const resetRequest = useCallback(() => dispatch(actions.resetRequest()), [dispatch]);
    const sendResponse = useCallback(() => dispatch(actions.sendResponse()), [dispatch]);
    const setResponseMessage = useCallback((value) => dispatch(actions.setResponseMessage(value)), [dispatch]);
    const setSort = useCallback((column, type) => dispatch(actions.setSort(column, type)), [dispatch]);
    const closeTicket = useCallback(() => dispatch(actions.closeTicket()), [dispatch]);
    const showFormModal = useCallback(() => dispatch(dialog.actions.showDialog('help-desk-form-modal')), [dispatch]);
    const hideFormModal = useCallback(() => dispatch(dialog.actions.hideDialog('help-desk-form-modal')), [dispatch]);

    /* componentDidMount */
    useEffect(() => {
        fetchRequests();
        return () => {
            hideFormModal();
            resetState();
        };
    }, [fetchRequests, resetState, hideFormModal]);

    return (
        <Layout
            title={<Fragment><i className="fas fa-file-alt"></i> Help Desk Requests</Fragment>}
            history={props.history}
        >
            <Helmet><title>Help Desk Requests</title></Helmet>
            <div className="admin-help-desk-container">
                <h2>Help Desk Requests</h2>
                <Table
                    requests={requests}
                    fetching={fetching}
                    user={user}
                    pagination={pagination}
                    sort={sort}
                    showFormModal={showFormModal}
                    setIdModal={setIdModal}
                    setActivePage={setActivePage}
                    setRequest={setRequest}
                    setSort={setSort}
                />
            </div>
            <FormModal
                request={request}
                sending={sending}
                idModal={idModal}
                responseMessage={responseMessage}
                closingTicket={closingTicket}
                hideFormModal={hideFormModal}
                setIdModal={setIdModal}
                setRequestField={setRequestField}
                setRequest={setRequest}
                resetRequest={resetRequest}
                sendResponse={sendResponse}
                setResponseMessage={setResponseMessage}
                closeTicket={closeTicket}
            />
        </Layout>
    );
};

export default AdminHelpDesk;
